import React, { Component } from "react";
import { Card, Button, Form, Alert, OverlayTrigger, Tooltip, Container, Col, Row } from "react-bootstrap";
import { Redirect, NavLink } from 'react-router-dom'
import axios from 'axios'
import MaterialTable from 'material-table'
import { ThemeProvider } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles'
import AlertModal from './AlertModal'
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from "./Toaster/CommonToast";
import { validateAnnouncementForm } from "../utils/validation";
import { hasPermission } from './../utils/usePermission';

export default class Announcement extends Component {

  constructor(props) {
    super(props)

    this.state = {
      announcements: [],
      departments: [],
      title: "",
      description: "",
      userId: null,
      departmentId: null,
      hasError: false,
      errorMsg: '',
      completed: false,
      showEditModel: false,
      showAlertModel: false,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      loading: true
    }
  }

  componentDidMount() {

    axios({
      method: 'get',
      url: '/departments',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({ departments: res.data, loading: false })
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })

    axios({
      method: 'get',
      url: '/departmentAnnouncements',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({ announcements: res.data })
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
  }

  onDelete(announcement) {

    return event => {
      event.preventDefault()

      axios({
        method: 'delete',
        url: '/epartmentAnnouncements/' + announcement.id,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      })
        .then(res => {
          this.setState({
            hasError: true,
            errMsg: "An unexpected error occurred.",
            toastMessage: "Announcement deleted!",
            toastVariant: 'success',
            color: 'green',
            showToast: true,

          });
          setTimeout(() => {
            this.setState({ loading: false, showToast: false });
          }, 900);
        })
        .catch(err => {
          this.setState({ hasError: true, errorMsg: err.response.data.message })
          this.setState({
            hasError: true,
            errMsg: "An unexpected error occurred.",
            toastMessage: "Announcement not deleted!",
            toastVariant: 'danger',
            color: 'red',
            showToast: true,

          });
          setTimeout(() => {
            this.setState({ loading: false, showToast: false });
          }, 900);
        })

    }
  }

  handleChange = (event) => {
    const { value, name } = event.target;
    let errors = { ...this.state.errors };


    if (name === "title" && value.trim() !== "") {
      delete errors.title;
    }
    if (name === "description" && value.trim() !== "") {
      delete errors.description;
    }
    if (name === "selectedDepartment" && value.trim() !== "") {
      delete errors.selectedDepartment;
    }



    this.setState({
      [name]: value,
      errors,
    });
  };


  pushDepartments = () => {
    let items = []
    // items.push(<option key={584390} value="all">All departments</option>)
    this.state.departments.map((dept, index) => {
      items.push(<option key={index} value={dept.id}>{dept.departmentName}</option>)
    })
    return items
  }

  onSubmit = (event) => {
    this.setState({ loading: true });
    event.preventDefault()
    let departmentId = null
    if (this.state.selectedDepartment !== 'all') {
      departmentId = this.state.selectedDepartment
    }

    const errors = validateAnnouncementForm(
      this.state.title,
      this.state.description,
      this.state.selectedDepartment,
      // this.state.selectedDepartment,
      // this.state.amountSpent
    );
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }

    let data = {
      announcementTitle: this.state.title,
      announcementDescription: this.state.description,
      createdByUserId: JSON.parse(localStorage.getItem('user')).id,
      departmentId: departmentId
    }

    axios({
      method: 'post',
      url: 'departmentAnnouncements',
      data: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })

      .then(res => {
        this.setState({
          completed: true,
          toastMessage: "Announcement created successfully!",
          toastVariant: 'success',
          color: 'green',
          done: true,
          showToast: true,
        });

        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
          // this.props.history.push('/expense-report')
        }, 900);
      })
      .then(err => {
        console.log(err)
        this.setState({
          toastMessage: "Announcement not created",
          toastVariant: 'danger',
          color: 'red',
          showToast: true,
          loading: false
        });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
  }

  render() {
    // let closeAlertModel = () => this.setState({ showAlertModel: false })

    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })

    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          <Container className="pt-4">
            {this.state.completed ? <Redirect to="/announcement" /> : null}
            <div className="row">
              <div className="col-sm-12">
                <Card className="shadow-sm rounded border-0">
                  <Card.Header className="text-white"><strong>Add Announcement</strong></Card.Header>
                  <Card.Body>
                    <>
                      <Form onSubmit={this.onSubmit}>
                        <Row className="mb-3">
                          <Col xs={12} md={4} lg={4}>
                            <Form.Group>
                              <Form.Label className="required">Title</Form.Label>
                              <Form.Control
                                type="text"
                                value={this.state.title}
                                onChange={this.handleChange}
                                name="title"
                                placeholder="Enter the title"

                              />
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors.title && <small className="text-danger">{this.state.errors.title}</small>}
                            </span>
                          </Col>
                          <Col xs={12} md={4} lg={4}>
                            <Form.Group>
                              <Form.Label className="required">Department</Form.Label>
                              <Form.Control
                                as="select"
                                className="form-select"
                                value={this.state.selectedDepartment}
                                onChange={this.handleChange}
                                name="selectedDepartment"
                              >
                                <option value="">Choose Department...</option>
                                <option value="all">All Departments</option>
                                {this.pushDepartments()}
                              </Form.Control>
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors.selectedDepartment && <small className="text-danger">{this.state.errors.selectedDepartment}</small>}
                            </span>
                          </Col>
                          <Col xs={12} md={4} lg={4}>
                            <Form.Group>
                              <Form.Label className="required">Description</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={1}
                                value={this.state.description}
                                onChange={this.handleChange}
                                name="description"
                                placeholder="Enter the description"

                              />
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors.description && <small className="text-danger">{this.state.errors.description}</small>}
                            </span>
                          </Col>
                        </Row>
                        {hasPermission('M16B1') && (
                          <Button type="submit" variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" >Publish</Button>
                        )}
                      </Form>
                    </>
                  </Card.Body>
                </Card>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <Card className="shadow-sm rounded border-0">
                  <Card.Header className="text-white">
                    <div className="panel-title">
                      <strong>Announcement List</strong>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <ThemeProvider theme={theme}>
                      <MaterialTable
                        columns={[
                          { title: 'ID', field: 'id' },
                          { title: 'Title', field: 'announcementTitle' },
                          { title: 'Description', field: 'announcementDescription' },
                          { title: 'Created By', field: 'user.fullName' },
                          { title: 'Department', field: 'department.departmentName' },
                          {
                            title: 'Action',
                            render: rowData => (
                              <>
                                {hasPermission('M16B2') && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Delete Announcement</Tooltip>}
                                  >
                                    <Button onClick={this.onDelete(rowData)} size="sm"
                                      className="delete-btn"
                                      variant="outline-danger"><i className="fas fa-trash"></i></Button>
                                  </OverlayTrigger>
                                )}
                              </>
                            )
                          }
                        ]}
                        data={this.state.announcements}
                        options={{
                          rowStyle: (rowData, index) => {
                            if (index % 2) {
                              return { backgroundColor: '#f2f2f2' }
                            }
                          },
                          pageSize: 8,
                          pageSizeOptions: [5, 10, 20, 30, 50, 75, 100]
                        }}
                        title="Announcements"
                      />
                    </ThemeProvider>
                  </Card.Body>
                </Card>
              </div>
            </div>
            {/* {this.state.hasError ? (
              <Alert variant="danger" className="m-3" block>
                {this.state.errMsg}
              </Alert>
            ) : (<></>)} */}

          </Container>
        </CommonLoader>
      </>
    );
  }
}